import { SectionsSectionType, SectionType } from '@/calendesk/models/BuilderTypes'
import SectionConfiguration from '@/calendesk/models/SectionConfiguration'
import { trans } from '@/lib/calendesk-js-library/prototypes/trans'
import { SectionImageType } from '@/calendesk/models/DTO/Response/SectionImageType'
import { CreatorDefaultImage } from '@/calendesk/models/Creator/CreatorDefaultImage'

export default (): SectionConfiguration => {
  return {
    type: SectionType.SECTION,
    configuration: {
      component_id: SectionsSectionType.FEATURE_12,
      wb_position: 0,
      present_height: 600,
      wb_height__style_height__: 600,
      wb_min_height: 50,
      wb_text__html_text__: `${trans('wb_dummy_text_1')}<br><br><h4 class="text-h4">${trans('wb_dummy_text_title')}</h4>${trans('wb_dummy_text_1')}`,
      wb_buttons__array_cta_buttons__: [
        {
          title: trans('wb_dummy_text_more'),
          page_id: '',
          outlined: true,
          rounded: true,
          size: 'x-large',
          elevation: 0,
          is_functional: false
        },
        {
          title: trans('wb_dummy_text_employees'),
          page_id: '',
          outlined: false,
          rounded: true,
          size: 'x-large',
          is_functional: false
        }
      ],
      wb_container_fluid__checkbox__: false,
      wb_image_to_right__checkbox__: false,
      wb_align_center__checkbox__: true,
      wb_invert_colors__checkbox__: false
    },
    images: [
      {
        slug: 'img_1',
        type: SectionImageType.IMAGE,
        name: CreatorDefaultImage.getImage(2)
      }
    ]
  }
}
